import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "@/lib/api";

const pageName = (path) => {
  if (path === "/") return "Homepage";
  return path
    .replace("/", "")
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const deviceType = () => {
  const width = window.innerWidth;
  if (width < 768) return "Mobile";
  if (width < 1024) return "Tablet";
  return "Desktop";
};

const send = (payload) => {
  axios.post(`${API_BASE}/analytics`, payload).catch(() => {});
};

export const trackEvent = (event_type, payload = {}) => {
  send({
    event_type,
    path: window.location.pathname,
    page: pageName(window.location.pathname),
    source: document.referrer,
    device_type: deviceType(),
    ...payload,
  });
};

export default function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    trackEvent("page_view", {
      path: location.pathname,
      page: pageName(location.pathname),
    });
  }, [location.pathname]);

  useEffect(() => {
    const onClick = (event) => {
      if (location.pathname.startsWith("/admin")) return;
      const target = event.target.closest("a,button,[data-track]");
      if (!target) return;
      const label =
        target.getAttribute("data-track") ||
        target.getAttribute("aria-label") ||
        target.textContent?.trim()?.replace(/\s+/g, " ").slice(0, 80);
      if (!label) return;
      trackEvent(target.tagName === "A" || target.tagName === "BUTTON" ? "cta_click" : "section_interaction", {
        label,
        section: target.closest("section")?.id || target.closest("section")?.dataset?.testid || "",
      });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [location.pathname]);
}
